module.exports = __webpack_public_path__ + "img/gywm_01.b6945645.png";